var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPreference(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H34C37.3137 0 40 2.68629 40 6V30C40 33.3137 37.3137 36 34 36H6C2.68629 36 0 33.3137 0 30V6Z",
    fill: "#F6F9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 25.5C26.6667 24.337 26.6667 23.7555 26.5232 23.2824C26.2 22.217 25.3663 21.3834 24.301 21.0602C23.8278 20.9167 23.2463 20.9167 22.0834 20.9167H17.9167C16.7537 20.9167 16.1723 20.9167 15.6991 21.0602C14.6338 21.3834 13.8001 22.217 13.4769 23.2824C13.3334 23.7555 13.3334 24.337 13.3334 25.5M23.75 14.25C23.75 16.3211 22.0711 18 20 18C17.929 18 16.25 16.3211 16.25 14.25C16.25 12.1789 17.929 10.5 20 10.5C22.0711 10.5 23.75 12.1789 23.75 14.25Z",
    stroke: "#0C5ECA",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPreference);
export default __webpack_public_path__ + "static/media/user-preference.ab3d012578f4720d0d536c2ba636fd6b.svg";
export { ForwardRef as ReactComponent };